import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { FindTrucksAnnouncementPromptService } from './find-trucks-announcement-prompt.service';

export const FindTrucksAnnouncementPromptOverridesGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const findTrucksAnnouncementPromptService = inject(
    FindTrucksAnnouncementPromptService,
  );
  const location = inject(Location);

  const { searchParams } = new URL(location.href);

  if (
    searchParams.has('no_find_trucks_announcement') &&
    searchParams.get('no_find_trucks_announcement') !== 'false'
  ) {
    findTrucksAnnouncementPromptService.setIsFindTrucksAnnouncementDisabled(
      true,
    );
  }

  return true;
};
